/**
 * Docebo Session Dates model
 */
export class SessionDates {
  constructor(
    public date: string,
    public name: string,
    public duration: number,
    public endHour: string,
    public gmt: string,
    public idClassroom: number,
    public idLocation: number,
    public startHour: string,
    public timezone: string,
    public webinarTool?: string
  ) {}
}
